import { render, staticRenderFns } from "./distributorStockList.vue?vue&type=template&id=2a0a6b6a&scoped=true"
import script from "./distributorStockList.vue?vue&type=script&lang=js"
export * from "./distributorStockList.vue?vue&type=script&lang=js"
import style0 from "./distributorStockList.vue?vue&type=style&index=0&id=2a0a6b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a6b6a",
  null
  
)

export default component.exports